export const TOKEN_KEY = 'token'
export const RESORT_KEY = 'resort'



// WEBPACK FOOTER //
// ./src/services/constants.js